<div class="bo-layout">
    <!-- HEADER BACKOFFICE -->
    <header class="bo-header text-center border-b-2 border-2 bg-white">
        <div class="py-4 px-container flex justify-between lg:gap-0 gap-8 items-center min-h-[135px]">
            <i class="bi bi-list text-4xl font-bold hover:text-accent cursor-pointer" (click)="sidebar=true"></i>

            <img src="../../../assets/images/logo.svg" alt="Logo TeatroColosseo" class="logo w-60 cursor-pointer focus-visible:outline-none lg:block hidden" routerLink="/backoffice">

            <i class="bi bi-box-arrow-right text-4xl font-bold hover:text-accent cursor-pointer" (click)="onLogOut()"></i>
        </div>
    </header>
    <!-- HEADER BACKOFFICE -->

    <div class="bo-main">
        <router-outlet></router-outlet>
    </div>
</div>

<!-- SIDEBAR BACKOFFICE -->
<div class="sidebar-backoffice">

    <p-sidebar #sidebarRef [(visible)]="sidebar" styleClass="lg:w-[30rem] w-full">
        <ng-template pTemplate="headless">
            <div class="flex flex-col h-full">
                <div class="flex items-center justify-between px-6 py-8 shrink-0">
                    <img src="../../../assets/images/logo.svg" alt="Logo TeatroColosseo" class="logo w-40 focus-visible:outline-none">
                    <span>
                        <i class="bi bi-x-lg text-3xl hover:font-bold cursor-pointer" (click)="closeCallback($event)"></i>
                    </span>
                </div>
                <div class="links-backoffice px-6 pt-6 pb-8 flex flex-col justify-between h-full">
                    <ul class="list-none divide-y divide-gray-600/20">

                        <li routerLink="/backoffice/home" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Home</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/spettacoli" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Spettacoli</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/area-compagnie" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Area Compagnie</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/ditte-interventi" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Fornitori, Manutenzioni e Verifiche</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/calendario-interventi" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Calendario interventi</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/info" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Info</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/carnet" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Carnet</span>
                            </a>
                        </li>
                        <li  routerLink="/backoffice/abbecedario" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Abbecedario</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/contatti" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Contatti</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/news" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">News</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/stagione" routerLinkActive="active" (click)="closeCallback($event)" *ngIf="user?.tipo == 'Amministratore'">
                            <a class="link">
                                <span class="font-medium">Stagione</span>
                            </a>
                        </li>
                        <!-- <li  routerLink="/backoffice/making-teca" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Making Teca</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/amministrazione-trasparente" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Amministrazione Trasparente</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/newsletter" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Newsletter</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/vouchers" routerLinkActive="active" (click)="closeCallback($event)">
                            <a class="link">
                                <span class="font-medium">Vouchers</span>
                            </a>
                        </li>
                        <li routerLink="/backoffice/configurazioni" routerLinkActive="active" (click)="closeCallback($event)" *ngIf="user?.tipo == 'Amministratore'">
                            <a class="link">
                                <span class="font-medium">Configurazioni</span>
                            </a>
                        </li>-->
                        <li routerLink="/backoffice/utenti" routerLinkActive="active" (click)="closeCallback($event)" *ngIf="user?.tipo == 'Amministratore'">
                            <a class="link">
                                <span class="font-medium">Utenti</span>
                            </a>
                        </li>
                    </ul>
                    <ul class="divide-y divide-gray-600/20">
                        <!-- <li>
                            <a class="link" target="_blank" routerLink="/" rel="bookmark">
                                <span class="font-medium">Torna al sito</span>
                            </a>
                        </li> -->
                        <li (click)="password = true">
                            <a class="link">
                                <span class="font-medium">Cambia password</span>
                            </a>
                        </li>
                        <li (click)="onLogOut()">
                            <a class="link">
                                <span class="font-medium">Esci</span>
                            </a>
                        </li>
                    </ul>


                </div>

            </div>
        </ng-template>
    </p-sidebar>
</div>
<!-- SIDEBAR BACKOFFICE -->


<!-- MODAL PASSWORD -->
<p-dialog [visible]="password" [style]="{width: '50%'}" header="Cambia la tua password" [modal]="true" class="p-fluid" (visibleChange)="password = false">
    <ng-template pTemplate="content">

        <form [formGroup]="formPassword" (ngSubmit)="onPassword()">
            <div class="flex flex-col gap-8">
                <div class="flex lg:flex-row flex-col gap-8">
                    <div class="lg:w-1/2 w-full">
                        <label>* Nuova Password</label>
                        <p-password [toggleMask]="true" formControlName="password" placeholder="Password" [feedback]="false" class="w-full grid" autocomplete />
                        <small class="text-red-600 block mt-4 font-medium" *ngIf="formPassword.get('password')?.hasError('required') && (formPassword.get('password')?.dirty || formPassword.get('password')?.touched)">La password è obbligatoria!.</small>
                        <small class="text-red-600 block mt-4 font-medium" *ngIf="formPassword.get('password')?.hasError('minlength') && (formPassword.get('password')?.dirty || formPassword.get('password')?.touched)">Inserire almeno 4 caratteri!.</small>
                        <small class="text-red-600 block mt-4 font-medium" *ngIf="formPassword.hasError('mismatch') && (formPassword.get('password')?.dirty || formPassword.get('password')?.touched) && (formPassword.get('confirm_password')?.dirty || formPassword.get('confirm_password')?.touched)">Le due password non combaciano!.</small>
                    </div>
                    <div class="lg:w-1/2 w-full">
                        <label>* Conferma Nuova Password</label>
                        <p-password [toggleMask]="true" formControlName="confirm_password" placeholder="Conferma Password" [feedback]="false" class="w-full grid" autocomplete />
                        <small class="text-red-600 block mt-4 font-medium" *ngIf="formPassword.get('confirm_password')?.hasError('required') && (formPassword.get('confirm_password')?.dirty || formPassword.get('confirm_password')?.touched)">La password è obbligatoria!.</small>
                        <small class="text-red-600 block mt-4 font-medium" *ngIf="formPassword.get('confirm_password')?.hasError('minlength') && (formPassword.get('confirm_password')?.dirty || formPassword.get('confirm_password')?.touched)">Inserire almeno 4 caratteri!.</small>
                        <small class="text-red-600 block mt-4 font-medium" *ngIf="formPassword.hasError('mismatch') && (formPassword.get('password')?.dirty || formPassword.get('password')?.touched) && (formPassword.get('confirm_password')?.dirty || formPassword.get('confirm_password')?.touched)">Le due password non combaciano!.</small>
                    </div>
                </div>
                <div class="w-full flex lg:flex-row flex-col gap-4 justify-end">
                    <button type="submit" class="btn-outln-backoffice p-3 px-8 font-medium" [disabled]="!formPassword.valid">Modifica</button>
                    <button type="button" class="btn-danger-backoffice p-3 px-8 font-medium" (click)="password = false">Annulla</button>
                </div>
            </div>
        </form>
    </ng-template>
</p-dialog>
<!-- MODAL PASSWORD -->
